import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import mainbannerimage from "../../assets/Mainbanner/main.png";
import Modal from "../../components/modal/modal";

const EmployerRegister = () => {
  const { t, i18n } = useTranslation();
  const [modalMessage, setModalMessage] = useState(null);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    companyName: "", // Կազմակերպության անուն
    hvhh: "", // ՀՎՀՀ
    responsibleName: "", // Պատասխանատու անձի անուն
    responsibleSurname: "", // Պատասխանատու անձի ազգանուն
    tel: "", // Հեռախոսահամար
    email: "", // Էլ. Հասցե
    password: "", // Գաղտնաբառ
    repeatpassword: "",
    role: "company", // ֆիքսված դաշտ
  });
  const [view, setView] = useState(false);
  const handleView = () => {
    setView(!view);
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.repeatpassword) {
      setModalMessage({
        title: t("error"),
        text: t("passwordnomutch"),
        success: false,
        ok:t("ok"),
      });
      return;
    }
    try {
      const response = await fetch(
        "/api/employerregister.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...formData, lang: i18n.language?.slice(0, 2) || "am" }),
        }
      );
      const data = await response.json();
      if (data.success && data.needsEmailVerification) {
        setModalMessage({
          title: t("wellcome"),
          text: t("verify_email_sent"),
          success: true,
          ok: t("ok"),
          onClose: () => navigate("/registerchoose"),
        });
        return;
      }

      if (data.success) {
        setModalMessage({
          title: t("wellcome"),
          text: t("registersuccessfuly"),
          success: true,
          ok:t("ok"),
          onClose: () => navigate("/registerchoose"),
        });
      } else {
        setModalMessage({
          title: t("error"),
          text: data.message || t("thisemailusererror"),
          success: false,
          ok:t("ok"),
        });
      }
    } catch (err) {
      console.error("Register error:", err);
      setModalMessage({
        title: t("error"),
        text: t("errortitle"),
        success: false,
        ok:t("ok"),
      });
    }
  };
  return (
    <section
      className="opacity-0 py-[20px] animate-[showtitle_1s_forwards]"
      style={{
        backgroundImage: `url(${mainbannerimage})`,
      }}
    >
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          text={modalMessage.text}
          success={modalMessage.success} // 👈 проброс
          ok={modalMessage.ok}
          onClose={() => {
            if (modalMessage.onClose) modalMessage.onClose();
            setModalMessage(null);
          }}
        />
      )}
      <form
        onSubmit={handleSubmit}
        className="w-[500px] max-sm:w-[90%] h-auto m-[20px_auto] opacity-0
       animate-[showtitle_1s_forwards] transition-all duration-500 hover:-translate-y-3
        flex justify-start  bg-white items-start flex-col gap-3 max-sm:gap-0 rounded-2xl shadow-2xl shadow-black border-[2px]
        border-[#006674]"
      >
        <h3
          className="font-bold tracking-widest bg-[#006674] py-3 rounded-t-xl
       text-white w-full text-center uppercase text-3xl max-sm:text-xl"
        >
          {t("employertitle")}
        </h3>

        <div className="w-full p-5 flex justify-start items-start flex-col gap-1">
          <label
            htmlFor="companyName"
            className="text-[#006674] max-sm:text-sm"
          >
            {t("employername")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type="text"
            id="companyName"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
          />
          <label htmlFor="hvhh" className="text-[#006674] max-sm:text-sm">
            {t("tin")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type="text"
            id="hvhh"
            name="hvhh"
            value={formData.hvhh}
            onChange={handleChange}
          />

          <label
            htmlFor="responsibleName"
            className="text-[#006674] max-sm:text-sm"
          >
            {t("Nameofresponsibleperson")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type="text"
            id="responsibleName"
            name="responsibleName"
            value={formData.responsibleName}
            onChange={handleChange}
          />
          <label
            htmlFor="contactPerson"
            className="text-[#006674] max-sm:text-sm"
          >
            {t("LastNameofresponsibleperson")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type="text"
            id="responsibleSurname"
            name="responsibleSurname"
            value={formData.responsibleSurname}
            onChange={handleChange}
          />
          <label htmlFor="tel" className="text-[#006674] max-sm:text-sm">
            {t("phone")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type="tel"
            id="tel"
            name="tel"
            value={formData.tel}
            onChange={handleChange}
          />
          <label htmlFor="email" className="text-[#006674] max-sm:text-sm">
            {t("email")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />

          <label htmlFor="password" className="text-[#006674] max-sm:text-sm">
            {t("password")}
          </label>
          <div className="flex w-full justify-between items-center gap-3">
            <input
              className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
              type={view ? "text" : "password"}
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
            <button
              onClick={handleView}
              type="button"
              className="min-w-[40px] min-h-[40px] rounded-full bg-[#006674] text-white"
            >
              {view ? (
                <FontAwesomeIcon icon={faEyeSlash} />
              ) : (
                <FontAwesomeIcon icon={faEye} />
              )}
            </button>
          </div>
          <label
            htmlFor="repeatpassword"
            className="text-[#006674] max-sm:text-sm"
          >
            {t("repeatpassword")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border-[1px] border-gray-400 transition-all duration-200 focus:border-[#006674]
          focus:shadow-xl"
            type={view ? "text" : "password"}
            id="repeatpassword"
            name="repeatpassword"
            value={formData.repeatpassword}
            onChange={handleChange}
          />
          <Link
            to="/registerchoose"
            className="text-[#006674] mt-3 transition-all duration-200 hover:text-[#848484]"
          >
            {t("register2")}
          </Link>
          <button
            type="submit"
            className="py-2 px-4 w-full capitalize mt-3 bg-[#006674] text-white rounded-[30px]
          transition-all duration-200 hover:bg-[#848484]"
          >
            {t("register")}
          </button>
        </div>
      </form>
    </section>
  );
};

export default EmployerRegister;
